import {POSTALCODE_LENGTH} from '@/lib/format'

export const description =
  'Precisamos de algumas informações do imóvel para conseguir avaliar melhor'
export const roomsLabel = 'Possui quantos quartos?'
export const suitesLabel = 'Desses quartos, quantos são suítes?'
export const bathroomsLabel = 'Possui quantos banheiros com chuveiro?'
export const areaLabel = 'Qual é a área aproximada do imóvel?'
export const maintenanceFeeLabel = 'Quanto está o condomínio?'
export const garageSpotsLabel = 'Possui vaga de garagem?'
export const elementsValues = {
  rooms: [1, 2, 3, 4, 5, '+5'],
  suitesBathrooms: [0, 1, 2, 3, 4, '+4'],
  garageSpots: ['Não', 1, 2, 3, 4, 5]
}
export const STEPINFOCONSTS = {
  INITIAL_STEP: 'listing',
  INITIAL_TYPE: 'Apartamento',
  MIN_COMPLEMENT_LENGTH: 1,
  MIN_AREA_VALUE: 15,
  MAX_AREA_VALUE: 900,
  POSTALCODE_VALUE: POSTALCODE_LENGTH,
  MIN_FIELD_VALUE: 0
}

export const MINPERCENTAGE = {
  MIN: 94,
  SIMILARMIN: 70
}
export const MAXPERCENTAGE = {
  MAX: 106,
  SIMILARMAX: 130
}

export const sentences = [
  'Analisando dados do imóvel',
  'Buscando imóveis similares',
  'Refinando avaliação'
]

export const validateStep = (label, item, stepStates) =>
  !!stepStates[label][item]

export const isStepListingValid = (step, stepStates) => {
  if (step === 'listing') {
    let isValid =
      validateStep(step, 'address', stepStates) &&
      validateStep(step, 'addressData', stepStates) &&
      stepStates[step]['streetNumber'] > STEPINFOCONSTS.MIN_FIELD_VALUE &&
      stepStates[step]['postalCode'] &&
      stepStates[step]['postalCode'].length >= STEPINFOCONSTS.POSTALCODE_VALUE
    if (isValid && stepStates[step].types[0] !== 'Casa') {
      isValid =
        stepStates[step]['complement'] &&
        stepStates[step]['complement'].length > STEPINFOCONSTS.MIN_FIELD_VALUE
    }
    return isValid
  }
}
export const isStepInfoValid = (step, stepStates) => {
  if (step === 'info') {
    let isValid =
      validateStep(step, 'rooms', stepStates) &&
      stepStates[step]['suites'] >= STEPINFOCONSTS.MIN_FIELD_VALUE &&
      stepStates[step]['bathrooms'] >= STEPINFOCONSTS.MIN_FIELD_VALUE &&
      stepStates[step]['area'] > STEPINFOCONSTS.MIN_AREA_VALUE &&
      validateStep(step, 'garageSpots', stepStates)
    if (isValid && stepStates['listing'].types[0] !== 'Casa') {
      isValid =
        stepStates[step]['maintenanceFee'] >= STEPINFOCONSTS.MIN_FIELD_VALUE
    }
    return isValid
  }
}

export const isBackButtonDisabled = (steps, step) =>
  !(steps[step] && steps[step].stepBack)

export const isFwdButtonDisabled = (steps, step, stepStates) => {
  if (step === 'listing') {
    return !isStepListingValid('listing', stepStates)
  } else if (step === 'info') {
    return !isStepInfoValid('info', stepStates)
  } else {
    return !(steps[step] && steps[step].stepFwd)
  }
}

export const calcPercentage = (value, partialValue) => {
  return (value * partialValue) / 100
}
